import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { EmbryoService } from "src/app/Services/Embryo.service";
import { MetaService } from "src/app/Services/meta-data.service";
import { StaticPagesService } from "src/app/Services/static-pages.service";

@Component({
    selector: "embryo-UnderConstruction",
    templateUrl: "./UnderConstruction.component.html",
    styleUrls: ["./UnderConstruction.component.scss"],
})
export class UnderConstructionComponent implements OnInit {
    lang: any;
    environmentVariables: any;
    constructor(
        public embryoService: EmbryoService,
        private metaService: MetaService,
        private router: Router,
        private confgServ: StaticPagesService
    ) {
        this.confgServ.getenvConfig().subscribe((res) => {
            this.environmentVariables = res;
            if (this.lang == "en")
                this.metaService.setTitle(
                    `${
                        this.environmentVariables?.message_en ||
                        "Website Under Construction"
                    }`
                );
            else
                this.metaService.setTitle(
                    `${
                        this.environmentVariables?.message_ar ||
                        "الموقع تحت الانشاء"
                    }`
                );
        });
        this.embryoService.emitLang.subscribe((lang: any) => {
            this.lang = lang;
            if (this.environmentVariables?.data != undefined) {
                this.router.navigate(["/" + this.lang]);
                return;
            }
        });
    }
    ngOnInit() {
        this.confgServ.getenvConfig().subscribe((res) => {
            this.environmentVariables = res;
            if (this.lang == "en")
                this.metaService.setTitle(
                    `${
                        this.environmentVariables?.message_en ||
                        "Website Under Construction"
                    }`
                );
            else
                this.metaService.setTitle(
                    `${
                        this.environmentVariables?.message_ar ||
                        "الموقع تحت الانشاء"
                    }`
                );
        });
    }
}
